import api_base from './base';
import type {
  AdminFeedback,
  AdminFeedbackCreate,
  AdminLogsListResponse,
  AdminLogDetail,
  LogsStats,
  LogsStatsParams
} from '@/types/chatbot-admin';

const CHATBOT_BASE_URL = '/api/v1/chatbot';

export const chatbotAdminService = {
  // Feedback: super admin sees all, users see own (server enforces)
  getFeedback: async (params?: { cabinet?: string }): Promise<AdminFeedback[]> => {
    const response = await api_base.get(`${CHATBOT_BASE_URL}/feedback/`, { params });
    const payload: any = response.data;
    if (Array.isArray(payload)) {
      return payload as AdminFeedback[];
    }
    if (payload && Array.isArray(payload.results)) {
      return payload.results as AdminFeedback[];
    }
    return [];
  },

  submitFeedback: async (data: AdminFeedbackCreate): Promise<AdminFeedback> => {
    const response = await api_base.post(`${CHATBOT_BASE_URL}/feedback/`, data);
    return response.data;
  },

  // Logs with pagination and ordering (filters can be extended when backend exposes)
  getLogs: async (params?: {
    ordering?: string;
    page_size?: number;
    page?: number;
    cabinet?: string;
  }): Promise<AdminLogsListResponse> => {
    const response = await api_base.get(`${CHATBOT_BASE_URL}/logs/`, { params });
    return response.data;
  },

  getLogDetail: async (id: string): Promise<AdminLogDetail> => {
    const response = await api_base.get(`${CHATBOT_BASE_URL}/logs/${id}/`);
    return response.data;
  },

  // Get logs statistics
  getLogsStats: async (params?: LogsStatsParams): Promise<LogsStats> => {
    const response = await api_base.get(`${CHATBOT_BASE_URL}/logs/stats/`, { params });
    return response.data;
  },
};

export default chatbotAdminService;